module.exports = __webpack_public_path__ + "c787e4bd55fc611b77852b1202ea88ec.png";